'use strict';

angular.module('controllers')
	.directive('expandCollapse', function() {
		return {
			restrict: 'EA',
			link: function(scope, element, attrs){
				var el = angular.element(element[0].querySelector('#collapse-card'));
				el.bind('click', function (event) {
					angular.element(element[0].querySelector('.expand-collapse')).slideToggle('200',function() {
						angular.element(el[0].querySelector('i')).toggleClass('fa-plus fa-minus');
					});
				});
			}
		}

	});